//@ts-ignore
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarCellTimes } from 'wix-ui-tpa/dist/src/components/CalendarCell/types';
import ReactResizeDetector from 'react-resize-detector';
import ScreenReaderOnly from '../../presentationals/ScreenReaderOnly/ScreenReaderOnly';
import Cell from '../../presentationals/Cell/Cell';
import { st, classes } from './TableCell.st.css';
var TableCell = function (_a) {
    var timezone = _a.timezone, timeToDisplay = _a.timeToDisplay, events = _a.events, time = _a.time, render = _a.render, popperPlacement = _a.popperPlacement, popperStyle = _a.popperStyle, timeType = _a.timeType, _b = _a.current, current = _b === void 0 ? false : _b, alignment = _a.alignment, isStretchable = _a.isStretchable, _c = _a.isWeekEnd, isWeekEnd = _c === void 0 ? false : _c, localeToggle = _a.localeToggle, isMobile = _a.isMobile, onSelectCell = _a.onSelectCell, isBorderShown = _a.isBorderShown, isTodayClicked = _a.isTodayClicked, keyClickHandler = _a.keyClickHandler, selected = _a.selected, cellStyle = _a.cellStyle, _d = _a.className, className = _d === void 0 ? '' : _d, onKeyUp = _a.onKeyUp, focusEvent = _a.focusEvent;
    var t = useTranslation()[0];
    var _e = React.useState(0), cellHeight = _e[0], setCellHeight = _e[1];
    var _f = React.useState(0), eventTitleHeight = _f[0], setEventTitleHeight = _f[1];
    var _g = React.useState(0), eventTimeHeight = _g[0], setEventTimeHeight = _g[1];
    var _h = React.useState(0), dateHeight = _h[0], setDateHeight = _h[1];
    var _j = React.useState(true), isShrinking = _j[0], setIsShrinking = _j[1];
    //@ts-ignore
    var cellRef = React.useRef(null);
    React.useEffect(function () {
        var newCellHeight = cellRef.current.getBoundingClientRect().height - 10;
        if (selected) {
            // cellRef.current.focus();
        }
        setCellHeight(newCellHeight);
    }, [selected]);
    var resetCellHeight = function () {
        var newCellHeight = cellRef.current.getBoundingClientRect().height - 10;
        if (!isEqual(newCellHeight, cellHeight)) {
            setIsShrinking(newCellHeight < cellHeight);
            setCellHeight(newCellHeight);
        }
    };
    var isEqual = function (num1, num2) { return num1 === num2; };
    var handleDateResize = function (width, height) {
        if (!isEqual(height, dateHeight)) {
            setIsShrinking(height > dateHeight);
            setDateHeight(height);
        }
    };
    var handleEventTitleResize = React.useCallback(function (width, height) {
        if (!isEqual(height, eventTitleHeight)) {
            setIsShrinking(height > eventTitleHeight);
            setEventTitleHeight(height);
        }
    }, []);
    var handleEventTimeResize = React.useCallback(function (width, height) {
        if (!isEqual(height, eventTimeHeight)) {
            setIsShrinking(height > eventTimeHeight);
            setEventTimeHeight(height);
        }
    }, []);
    var isToday = timeType === CalendarCellTimes.today;
    return (
    //@ts-ignore
    React.createElement("td", { id: time, onKeyDown: keyClickHandler, onKeyUp: onKeyUp, className: st(classes.root, { isToday: isToday, isMobile: isMobile, isBorderShown: isBorderShown, selected: selected }, className), tabIndex: 0, style: cellStyle, "aria-current": isToday ? 'date' : null, ref: cellRef, onFocus: function () { return onSelectCell(time); }, onClick: focusEvent },
        React.createElement(ReactResizeDetector, { onResize: function () { return resetCellHeight(); } },
            React.createElement(Cell, { timeType: timeType, current: current, alignment: alignment, isStretchable: isStretchable, events: events, isWeekEnd: isWeekEnd, render: render, time: time, popperPlacement: popperPlacement, popperStyle: popperStyle, cellHeight: cellHeight, isShrinking: isShrinking, localeToggle: localeToggle, timeToDisplay: timeToDisplay, isBorderShown: isBorderShown, isMobile: isMobile, isTodayClicked: isTodayClicked, selected: selected, dateHeight: dateHeight, handleDateResize: handleDateResize, eventTitleHeight: eventTitleHeight, handleEventTitleResize: handleEventTitleResize, eventTimeHeight: eventTimeHeight, handleEventTimeResize: handleEventTimeResize, className: classes.CellExt, timezone: timezone })),
        React.createElement(ScreenReaderOnly, null, t('Google_Calendar_Events', { amount: events.length }))));
};
export default TableCell;
//# sourceMappingURL=TableCell.js.map